import { render, staticRenderFns } from "./ClientChatPopUp.vue?vue&type=template&id=95afaed8&scoped=true&"
import script from "./ClientChatPopUp.vue?vue&type=script&lang=js&"
export * from "./ClientChatPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ClientChatPopUp.vue?vue&type=style&index=0&id=95afaed8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95afaed8",
  null
  
)

export default component.exports